import { api } from '../api';

export type Chat = {
    question: string;
    chat_history: {
        inputs: {
            question: string;
        };
        outputs: {
            answer: string;
        };
    }[];
};

/**
 * Submits a chat object to the chatbot API
 * @param Chat chat the chat object to submit
 * @returns Promise<{answer: string}>
 */
export async function submitChat(chat: Chat) {
    try {
        const response = await api.post<{ answer: string }>({
            url: '/scores',
            body: { ...chat, chat_history: takeLast(chat.chat_history, 3) },
        });
        if (response.data) {
            return response.data;
        } else {
            throw response;
        }
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error submitting chat', error);
        return null;
    }
}

export const takeLast = <T>(arr: T[], n: number): T[] =>
    arr.slice(Math.max(arr.length - n, 0));
